export default __webpack_public_path__ + "static/media/taco-640w.5a9d6a7b.jpg";